import { remove } from 'lodash';
import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class EstateRelationshipType extends Enum {
  key!: string;
  value!: string;
  $isDisabled?: boolean;

  static AUNT_OR_UNCLE: EstateRelationshipType = {
    key: 'aunt_or_uncle',
    get value(): string {
      return Lang.t('nextofkin.aunt-or-uncle');
    }
  };

  static CHILD: EstateRelationshipType = {
    key: 'child',
    get value(): string {
      return Lang.t('beneficiary.child');
    }
  };

  static COMMON_LAW_PARTNER: EstateRelationshipType = {
    key: 'common_law_partner',
    get value(): string {
      return Lang.t('contact.common-partner');
    }
  };

  static EXECUTOR_PROFESSIONAL: EstateRelationshipType = {
    key: 'executor_professional',
    get value(): string {
      return Lang.t('estate.professional-executor');
    },
    $isDisabled: true
  };

  static FIRST_COUSIN: EstateRelationshipType = {
    key: 'first_cousin',
    get value(): string {
      return Lang.t('nextofkin.first-cousin');
    }
  };

  static FORMER_COMMON_LAW_PARTNER: EstateRelationshipType = {
    key: 'former_common_law_partner',
    get value(): string {
      return Lang.t('estate.former-common-law-partner');
    }
  };

  static FORMER_SPOUSE: EstateRelationshipType = {
    key: 'former_spouse',
    get value(): string {
      return Lang.t('estate.former-spouse');
    }
  };

  static FRIEND: EstateRelationshipType = {
    key: 'friend',
    get value(): string {
      return Lang.t('estate.friend');
    }
  };

  static GRAND_CHILD: EstateRelationshipType = {
    key: 'grand_child',
    get value(): string {
      return Lang.t('estate.grandchild');
    }
  };

  static GRAND_PARENT: EstateRelationshipType = {
    key: 'grand_parent',
    get value(): string {
      return Lang.t('nextofkin.grandparent');
    }
  };

  static NIECE_OR_NEPHEW: EstateRelationshipType = {
    key: 'niece_or_nephew',
    get value(): string {
      return Lang.t('estate.niece-nephew-or');
    }
  };

  static PARENT: EstateRelationshipType = {
    key: 'parent',
    get value(): string {
      return Lang.t('estate.parent');
    }
  };

  static SIBLING: EstateRelationshipType = {
    key: 'sibling',
    get value(): string {
      return Lang.t('estate.sibling');
    }
  };

  static SPOUSE: EstateRelationshipType = {
    key: 'spouse',
    get value(): string {
      return Lang.t('accounting.spouse');
    }
  };

  static STEPCHILD: EstateRelationshipType = {
    key: 'stepchild',
    get value(): string {
      return Lang.t('estate.stepchild');
    }
  };

  static OTHER: EstateRelationshipType = {
    key: 'other',
    get value(): string {
      return Lang.t('asset.other');
    }
  };

  static getValues<EstateRelationshipType>(): EstateRelationshipType[] {
    const values: EstateRelationshipType[] = super.getValues<EstateRelationshipType>();

    if (getters.auth.getCurrentEstate()?.isCommonLawJurisdiction ?? true) {
      return values;
    }

    // @ts-ignore
    remove(values, { key: this.COMMON_LAW_PARTNER.key });
    // @ts-ignore
    remove(values, { key: this.FORMER_COMMON_LAW_PARTNER.key });

    return values;
  }

  static getPartnerTypeKeys(): string[] {
    if (getters.auth.getCurrentEstate()?.isCommonLawJurisdiction ?? true) {
      return [this.SPOUSE.key, this.COMMON_LAW_PARTNER.key];
    }

    return [this.SPOUSE.key];
  }
}
